import React from "react";

import ReactHelmet from "../../components/react-helmet/react-helmet";
const Texasheader = () => {
  return (
    <ReactHelmet
      title={"Facilities For Sober Living in Texas | Taste Recovery"}
      description={
        "Browse available facilities for sober living in Texas offering safe, peer-reviewed & supportive environments to help individuals maintain lasting recovery."
      }
    />
  );
};

export default Texasheader;
